export const PROJECT_UUID = 'PROJECT_UUID';
export const PROJECTJSON = 'PROJECTJSON';
export const ACTIVEVIDEOUUID = 'ACTIVEVIDEOUUID';
export const ACTIVETEXTUUID = 'ACTIVETEXTUUID';
export const ACTIVEIMAGEUUID = 'ACTIVEIMAGEUUID';
export const ACTIVEAUDIOUUID = 'ACTIVEAUDIOUUID';
export const CHANGEDJSON = 'CHANGEDJSON';
export const SAVESTATE = 'SAVESTATE';
export const SEQUENCESTATUS = 'SEQUENCESTATUS';
export const SEQUENCENUMBER = 'SEQUENCENUMBER';
export const THUMBNAILS = 'THUMBNAILS';
export const UPLOADINGFILES = 'UPLOADINGFILES';
export const TIMELINEFIT = 'TIMELINEFIT';
export const SUBCREATING = 'SUBCREATING';
export const THUMBNAILSTATE = 'THUMBNAILSTATE';
export const EDITSUBTITLE = 'EDITSUBTITLE';
export const PROJECTVOLUME = 'PROJECTVOLUME';
export const FULLSCREENFLAG = 'FULLSCREENFLAG';
export const STRETCHSCREENFLAG = 'STRETCHSCREENFLAG'
export const CAPTURETHUMBNAIL = 'CAPTURETHUMBNAIL';
export const ADDEDTEMPLATE = 'ADDEDTEMPLATE';
export const SUBTITLEPOSY = 'SUBTITLEPOSY';
export const AUTOSAVESTATUS = 'AUTOSAVESTATUS';
export const EDITOR_HISTORY_STATE = 'EDITOR_HISTORY_STATE';
export const EDITOR_HISTORY_UNDO = 'EDITOR_HISTORY_UNDO';
export const EDITOR_HISTORY_REDO = 'EDITOR_HISTORY_REDO';
export const EDITOR_HISTORY_RESET = 'EDITOR_HISTORY_RESET';

export const projectdata = {
  thumbNails: {},
  projectUUID: '',
  projectJSON: {},
  activeVideoUUID: [],
  activeTextUUID: [],
  activeImageUUID: [],
  activeAudioUUID: [],
  changedJSON: null,
  sequenceStatus: true,
  sequenceNumber: { m: 0, c: 0 },
  subcreating: false,

  subtitlePosY: 5.375,

  uploadingFiles: {},
  timelineFit: false,

  saveState: false,
  thumbnailState: false,
  editSubtitle: false,

  projectVolume: 100,
  fullScreenFlag: false,
  stretchScreenFlag: false,
  captureThumbnailFlag: false,
  addedTemplate: false,
  autosaveStatus: { state: 'saved', updatedAt: null },
  editorHistory: { undoCount: 0, redoCount: 0, lastAction: null }
};

